// extracted by mini-css-extract-plugin
export default {"tile":"start-page-tile_tile__8ZClt","preview":"start-page-tile_preview__bW3Qe"};